export default ($axios) => ({
  fetch(query) {
    return $axios.get('/admin/products', { params: query }).then((response) => response.data);
  },
});
